import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

import { Container } from '@/components/common';
import { useMyInfo } from '@/hooks/auth.hook';

const Dashboard = () => {
  const { data } = useMyInfo();

  const loginDate = dayjs(new Date(data?.lastLoginDateTime || new Date())).format('YYYY-MM-DD HH시 mm분');

  return (
    <Container title='시코랩 관리자 페이지에 오신 것을 환영합니다😀'>
        <ContentWrapper>
          <LoginInfoBox>
            <div>
              <span className='title'>마지막 접속 IP:</span>
              <p>{data?.remoteAddr || ''}</p>
            </div>
            <div>
              <span className='title'>마지막 로그인 시간:</span>
              <p>{loginDate}</p>
            </div>
          </LoginInfoBox>
        </ContentWrapper>
    </Container>
  );
};

export default Dashboard;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;

const LoginInfoBox = styled.div`
  display: flex;
  column-gap: 50px;

  span.title {
    font-size: 1rem;
    font-weight: bold;
  }

  p {
    margin-top: 5px;
    padding-left: 20px;
    font-weight: bolder;
    color: #1976d2;
  }
`;